import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import { addHours, format, getDay } from 'date-fns';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Recdal from 'recdal';
import Loader from 'react-loader-spinner';
import DatePicker from 'react-modern-calendar-datepicker';

import { GET } from '../../services/api';

import Breadcumbs from '../../components/Breadcumbs';
import Button from '../../components/Button';
import Fallback from '../../components/Fallback';
import { Form, Select } from '../../components/Form';
import { Heading1 } from '../../components/Typography';
import Script from '../../components/Script';
import VoicesUploader from '../../components/VoicesUploader';
import Infos from './Infos';
import {
	Column,
	Container,
	DailyDataFallback,
	Grid,
	OpenUploadButtonContainer,
	SendButtonsContainer,
	SubContainer,
} from './styles';

import { AuthContext } from '../../store/Auth';
import { toast } from 'react-toastify';
import { useMemo } from 'react';
import { PlaylistGeneration } from './GeneratePlaylist';
import { ViewPlaylist } from './ViewPlaylist';
import { notify } from '../../components/Notification';
import { InputContainer } from '../../components/Form/styles';

const breadcumbsStack = [
	{ label: 'Início', pathname: '/' },
	{ label: 'Enviar Offs', pathname: null },
];

const SendOffs = () => {
	const { user } = useContext(AuthContext);
	const uploaderModalRef = useRef(null);

	const [contracts, setContracts] = useState([]);
	const [contract, setContract] = useState(null);

	const [isLoadingInitialData, setIsLoadingInitialData] = useState(true);
	const [isCalculatingOffs, setIsCalculatingOffs] = useState(false);
	const [isFetchingScripts, setIsFetchingScripts] = useState(false);

	const [scripts, setScripts] = useState([]);
	const [date, setDate] = useState(null);
	const [pickerValue, setPickerValue] = useState(null);

	const [storedOffs, setStoredOffs] = useState(null);

	// Fetch Initial Data
	useEffect(() => {
		const fetchInitialData = async () => {
			setIsLoadingInitialData(true);

			try {
				const { data } = await GET(`/api/v2/contracts?caster=${user._id}`);

				const contracts = data.contracts
					.filter(({ status, program }) => status === 1 && program !== null)
					.map((item) => ({
						label: (
							<>
								<strong>{item?.hirer?.radioName}</strong>
								<span> - {item?.program?.name}</span>
							</>
						),
						value: {
							_id: item?._id,
							radio: item?.hirer,
							script: item?.script,
							program: item?.program,
							playlistPrivilege: item?.playlistPrivilege,
						},
					}));

				setContracts(contracts);
				setIsLoadingInitialData(false);
			} catch (error) {
				toast.error('Erro ao buscar os programas, recarregue a página');
			}
		};

		fetchInitialData();
	}, [user]);

	// Fetch Scripts
	useEffect(() => {
		const fetchProgramScripts = async () => {
			setIsFetchingScripts(true);
			const programId = contract.value.program._id;
			const userId = contract.value.radio._id;

			try {
				const { data } = await GET(
					`api/v2/scripts?program=${programId}&userId=${userId}&isShared=false`
				);

				setScripts(data.scripts);
			} catch (error) {
				setScripts([]);
				toast.error('Erro ao buscar os modelos, recarregue a página');
			}

			setIsFetchingScripts(false);
		};

		if (contract) {
			fetchProgramScripts();
		}
	}, [contract]);

	useEffect(() => {
		const fetchStoredOffs = async () => {
			setIsCalculatingOffs(true);

			try {
				setStoredOffs(null);

				const programId = contract?.value?.program?._id;
				const dateRelease = format(new Date(date), 'dd/MM/yyyy');
				const { data: storedOffs } = await GET(
					`/api/v2/offs?program=${programId}&dateRelease=${dateRelease}`
				);

				setStoredOffs(storedOffs.offs.length);
				setIsCalculatingOffs(false);
			} catch (error) {
				console.log(error);
				notify('error', 'Erro ao calcular os offs necessários, recarregue a página');
			}
		};

		if (date && contract) {
			fetchStoredOffs();
		}
	}, [date, contract]);

	const script = useMemo(() => {
		if (!date || !scripts.length) {
			return null;
		}

		const weekDay = getDay(new Date(date));
		const script =
			scripts.find((p) => p.weekDay === weekDay) ||
			scripts.find((p) => p._id === contract.value.script._id);

		return script;
	}, [contract, date, scripts]);

	const neededOffs = useMemo(() => {
		if (!script || isCalculatingOffs) {
			return null;
		}

		const scriptOffs = script.body.filter((e) => e.type === 'OFF-MAIN').length;

		return scriptOffs - storedOffs;
	}, [script, isCalculatingOffs, storedOffs]);

	const isPickVoicesBtnEnabled = useMemo(() => {
		if (isLoadingInitialData || isCalculatingOffs || isFetchingScripts) {
			return false;
		}

		return neededOffs !== null && neededOffs > 0;
	}, [isCalculatingOffs, isFetchingScripts, isLoadingInitialData, neededOffs]);

	const dateInputValue = useMemo(() => {
		if (!pickerValue) {
			return '';
		}

		return [
			String(pickerValue.day).padStart(2, '0'),
			String(pickerValue.month).padStart(2, '0'),
			pickerValue.year,
		].join('/');
	}, [pickerValue]);

	if (isLoadingInitialData) {
		return <Fallback />;
	}

	return (
		<>
			<Container>
				<Breadcumbs stack={breadcumbsStack} />
				<Heading1
					onClick={() => {
						console.log(pickerValue);

						if (pickerValue) {
							console.log();
						}
					}}>
					Enviar Offs
				</Heading1>

				<Grid>
					<Column>
						<SubContainer>
							<Form>
								<Select
									size={4}
									name='contract'
									label='Selecione o contrato'
									options={contracts}
									onChange={(contract) => {
										setScripts([]);
										setContract(contract);
									}}
								/>

								<InputContainer size={4} className='__input'>
									<label>Selecione a data</label>
									<DatePicker
										value={pickerValue}
										onChange={({ day, month, year }) => {
											setPickerValue({ day, month, year });
											setDate(addHours(new Date(year, month - 1, day), 3));
										}}
										wrapperClassName='date-input'
										renderInput={({ ref }) => (
											<input
												ref={ref}
												readOnly
												placeholder='Selecione uma data'
												value={dateInputValue}
												style={{
													zIndex: 0,
													width: '100%',
													height: 38,
													padding: '0 12px',
													border: '1px solid #dedede',
													borderRadius: 15,
													fontSize: 15,
													outline: 'none',
												}}
											/>
										)}
									/>
								</InputContainer>
							</Form>

							<div style={{ marginTop: '16px' }}>
								{isFetchingScripts ? (
									<DailyDataFallback>
										<Loader type='TailSpin' height={20} width={20} color='#d8b135' />
										<span>Buscando modelos do programa</span>
									</DailyDataFallback>
								) : script ? (
									<Script script={script} />
								) : null}
							</div>
						</SubContainer>
					</Column>

					<Column>
						<SubContainer style={{ minHeight: 162 }}>
							<SendButtonsContainer>
								<OpenUploadButtonContainer>
									<Button
										onClick={() => uploaderModalRef.current.open()}
										disabled={!isPickVoicesBtnEnabled}>
										Selecionar Vozes
									</Button>
								</OpenUploadButtonContainer>

								<div className='playlist-buttons'>
									<PlaylistGeneration contract={contract} />
									<ViewPlaylist contract={contract} />
								</div>
							</SendButtonsContainer>
						</SubContainer>

						<SubContainer>
							<Infos
								contract={contract}
								isCalculatingOffs={isCalculatingOffs}
								neededOffs={neededOffs}
								script={script}
							/>
						</SubContainer>
					</Column>
				</Grid>
			</Container>

			<Recdal
				ref={uploaderModalRef}
				closeOnOverlayClick={false}
				overlay={{
					style: {
						background: 'rgba(0, 0, 0, .4)',
					},
				}}>
				<VoicesUploader
					modalRef={uploaderModalRef}
					date={date}
					contract={contract}
					neededOffs={neededOffs}
					onUploadSuccess={() => {
						uploaderModalRef.current.close();
						setStoredOffs(neededOffs);
						notify('success', 'Seus offs foram enviados com sucesso');
					}}
				/>
			</Recdal>
		</>
	);
};

export default SendOffs;
